<template>
  <highcharts :options="chart_options"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";

export default {
  name: "bar_chart_horizontal",
  components: {
    highcharts: Chart,
  },
  props: {
    data: Object,
    reversed: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      chart_options: {},
    };
  },
  mounted() {
    this.loadChart();
  },
  methods: {
    loadChart() {
      this.chart_options = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: " ",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: this.data.x,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total",
          },
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.2f}%)<br/>',
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          maxHeight: 100,
          reversed: this.reversed,
        },
        plotOptions: {
          series: {
            stacking: "percent",
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.percentage:.2f}%",
            },
          },
        },
        series: this.data.y,
      };
    },
  },
};
</script>